import { render, staticRenderFns } from "./FinalReportInvoicesInvoiceGeneralDataRow.vue?vue&type=template&id=ecf5a3cc&scoped=true&"
import script from "./FinalReportInvoicesInvoiceGeneralDataRow.vue?vue&type=script&lang=js&"
export * from "./FinalReportInvoicesInvoiceGeneralDataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf5a3cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VLayout})
